import PropTypes from 'prop-types';
import React from 'react';

function BreakEmaWrapper({ softOrder, Component, ...rest }) {
  const details = {
    tacticName: 'BREAK_EMA',
    category: 'Setup',
    type: 'Break EMA',
    domain: 'Underlying',
  };
  const periodLength = softOrder.periodLength;
  const priceToBreak = softOrder.priceToBreak;
  const candleDuration = softOrder.candleDuration;

  return (
    <Component
      details={details}
      periodLength={periodLength}
      priceToBreak={priceToBreak}
      candleDuration={candleDuration}
      {...rest}
    />
  );
}

BreakEmaWrapper.propTypes = {
  Component: PropTypes.any,
  softOrder: PropTypes.shape({
    candleDuration: PropTypes.any,
    periodLength: PropTypes.any,
    priceToBreak: PropTypes.any
  })
};

export default BreakEmaWrapper;
